import React, { useEffect, useState } from "react";
import { Table, Spinner, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchContestDetails } from "store/actions/contestAction";

const tableHeaders = ["Athlete Id", "First Name", "Last Name", "Email"];

const ContestAthletes = ({ contestId }) => {
  const dispatch = useDispatch();
  const { contestDetails } = useSelector((state) => state.contest);

  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleLoadMore = () => {
    setIsLoading(true);
    dispatch(
      fetchContestDetails({
        collectionName: "contest_athletes",
        contestId,
        lastVisible: contestDetails?.lastVisible,
      })
    ).finally(() => setIsLoading(false));
  };

  useEffect(() => {
    setIsFetching(true);
    dispatch(
      fetchContestDetails({ collectionName: "contest_athletes", contestId })
    ).finally(() => setIsFetching(false));
  }, []);

  return (
    <div className="p-0">
      {isFetching ? (
        <div className="text-center py-4 text-primary">
          <Spinner animation="border" size="md" />
        </div>
      ) : (
        <>
          <Table
            responsive
            border
            className="table-centered table-nowrap rounded mb-0 border border-top-0"
          >
            <thead className="thead-light">
              <tr>
                {tableHeaders?.map((header, index) => (
                  <th key={index} className="border-0">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {contestDetails?.data?.length > 0 ? (
                contestDetails?.data?.map((detail, index) => (
                  <tr key={index}>
                    <td className="border-0">{detail?.athleteID || "N/A"}</td>
                    <td className="border-0 text-capitalize">
                      {detail?.firstName}
                    </td>
                    <td className="border-0 text-capitalize">
                      {detail?.lastName}
                    </td>
                    <td className="border-0">{detail?.email}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={tableHeaders?.length}
                    className="text-center py-4"
                  >
                    No Athlete
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          {contestDetails?.hasMore && (
            <div className="text-center py-2">
              <Button
                variant="primary"
                onClick={handleLoadMore}
                disabled={isFetching || isLoading}
                style={{ width: "100px", height: "40px", fontSize: "14px" }}
              >
                {isLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Load More"
                )}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ContestAthletes;
